module.exports = __webpack_public_path__ + "static/media/CV-Waleed.3db4f237.jpg";